<template>
  <n-modal v-model:show="showModal" style="width: 4rem" preset="card" title="Version History">
    <div style="background-color: #fff">
      <ContentsFormat :popup-contents="popupContents.data" />
    </div>
    <template #footer
      ><div class="footer">
        <n-button type="primary" @click="handleClick">Close</n-button>
      </div></template
    >
  </n-modal>
</template>

<script lang="ts" setup>
import { ref, onMounted, reactive } from 'vue';

import { FeatureNoticeResp, getFeatureNotice, readFeatureNotice } from '@/api/login';

import ContentsFormat from './ContentsFormat/index.vue';

const showModal = ref(false);
const popupContents = reactive<{ data?: FeatureNoticeResp[] }>({});

const handleClick = () => {
  showModal.value = false;
};

const getNotice = async () => {
  try {
    const featureNoticeRes = await getFeatureNotice();
    if (!featureNoticeRes.length) return;
    popupContents.data = featureNoticeRes;
    showModal.value = true;

    const isFeatureNotice = await readFeatureNotice({ id: featureNoticeRes?.[0]?.id || 0 });
    if (isFeatureNotice) showModal.value = true;
  } catch (error) {
    console.error('err: getNotice', error);
  }
};

onMounted(() => {
  getNotice();
});
</script>

<style lang="scss" scoped>
.popup-banner {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.title {
  font-size: 24px;
}

.footer {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.list {
  max-height: 30vh;
  overflow: auto;
}
</style>
